import http from '@/libs/axios'

export function getAllUsers(params = { page_size: 500 }) {
  return http({
    method: 'GET',
    url: '/users/users/',
    params,
  })
}

export function getTaskManagerList(params) {
  return http({
    method: 'GET',
    url: 'task_manager/tasks/',
    params,
  })
}

export function getOneTask(id) {
  return http({
    method: 'GET',
    url: `task_manager/tasks/${id}/`,
  })
}

export function addNewTast(data) {
  return http({
    method: 'POST',
    url: '/task_manager/tasks/',
    data,
  })
}

export function updateTask({ data, id }) {
  return http({
    method: 'PATCH',
    url: `/task_manager/tasks/${id}/`,
    data,
  })
}

export function getPrioritiesList() {
  return http({
    method: 'GET',
    url: '/task_manager/priorities/',
  })
}

export function getTaskStatistics() {
  return http({
    method: 'GET',
    url: '/task_manager/tasks/statistics/',
  })
}
export function getCalendarTaskList(params) {
  return http({
    method: 'GET',
    url: '/task_manager/tasks/calendar_list/',
    params,
  })
}
export function getComments(params) {
  return http({
    url: 'files/comments/',
    method: 'GET',
    params,
  })
}
export function createComments(data) {
  return http({
    url: 'files/comments/',
    method: 'POST',
    data,
  })
}
export function deleteComment(id) {
  return http({
    url: `files/comments/${id}/`,
    method: 'DELETE',
  })
}

export function getAttachmentFiles(params) {
  return http({
    url: '/files/attachments/',
    method: 'GET',
    params,
  })
}
export function addAttachmentFiles(data) {
  return http({
    url: '/files/attachments/',
    method: 'POST',
    data,
  })
}
export function deleteAttachmentFiles(id) {
  return http({
    url: `/files/attachments/${id}/`,
    method: 'DELETE',
  })
}
